import type { AxiosInstance } from 'axios';
import type { ChatItem } from '@/types/apiTypes';
import { generate } from '@/actions/generate';

const generateChatTitle = async (
  api: AxiosInstance,
  chat_history: ChatItem[],
): Promise<string> => {
  // Build conversation text from chat history
  const conversationText = chat_history
    .map((message) => `${message.role}: ${message.content}`)
    .join('\n\n');

  const messages = [
    {
      role: 'user' as const,
      content: `Please generate a concise, descriptive title (maximum 50 characters) for this conversation. The title should capture the main topic or question being discussed. Return only the title, nothing else.

Conversation:
${conversationText}`,
    },
  ];

  const response = await generate(
    api,
    messages,
    100, // max_tokens - enough for a short title
    0.7, // temperature
    0.9, // top_p
  );

  if (!response.body) {
    return 'New Chat';
  }
  const reader = response.body.getReader();
  let line = '';
  let title = '';

  try {
    while (true) {
      const { done, value } = await reader.read();
      line += new TextDecoder().decode(value);

      if (line.endsWith('\n')) {
        const lines = line
          .trim()
          .split('\n')
          .filter((line) => line);

        for (let i = 0; i < lines.length; i++) {
          const data = lines[i].substring(5).trim();
          if (data === '[DONE]') {
            return title.trim();
          } else {
            const result = JSON.parse(data);
            if (result?.choices && result?.choices[0]?.delta?.content) {
              title += result.choices[0].delta.content;
            } else if (result?.token?.text) {
              title += result.token.text;
            }
          }
        }
        line = '';
      }

      if (done) {
        return title.trim();
      }
    }
  } catch (error) {
    console.error('Error generating chat title:', error);
    return 'New Chat'; // fallback to default title
  }
};

export default generateChatTitle;

